module.exports = __webpack_public_path__ + "static/media/quote2.47f82ff6.jpeg";